import React from 'react';
import {useWindowSize} from '../helpers/context'

export const Body = props => (
  <div className={props.className + ' dark-version fixed-position admin-template'}>
    {props.children}
  </div>
)

export const Layout = (props) => {
  return(
    <div className={`${props.className == undefined ? '' : props.className} d-flex`}>
      {props.children}
    </div>
  )
}

export const HeaderLayout = (props) => {
  return (
    <div style={{height: props.height}} className={props.className}>
    	{props.children}
    </div>
  )
}

export const Sidebar = (props) => {
  const className = useWindowSize().width < 700 ? ' initial-closed' : ''
  return (
    <div className={props.className + className} style={{width: props.width + 'px'}}>
    	{props.children}
    </div>
  )
}

export const ContentLayout = (props) => {
  return (
    <div className={props.className} style={{width: props.width}}>
    	{props.children}
    </div>
  )
}


export const SidebarwithContentLayout = (props) => {
  return (
    <div className={props.className + ' d-md-flex flex-row theme'}>
    	{props.children}
    </div>
  )
}
export const ComponentsContainer = (props) => {
    return (
        <div className={props.className + ' rounded admin-primary-bg admin-components-block overview-hidden'} style={{backgroundColor: props.fillbg}}>
            {props.children}
        </div>
    )
}



